var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBranch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Sunflower"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Shovel"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Bird_House"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Cactus"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Watering_Can"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Ice_Cream"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Flower_Pot"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Tree"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Easter_Eggs"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Lemonade"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Lily"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Log"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Axe"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Branch"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m112.26 63.51c-12.36-.74-26.06.46-36.95 6.44-4.78 2.62-19.17 19.08-24.16 24.97-.7.83-1.22 1.44-1.5 1.79-.01.02-.02.03-.03.06-.01.02-.05.04-.06.06-8.71 10.69-19.88 19.84-31.97 27.17-8.86-3.16-14-11.79-13.06-23.41 4.32-2.33 8.64-4.94 12.78-7.69 4.13-2.76 8.09-5.65 11.68-8.56-4.17-12.95-4.71-26.38-1.24-39.7.42-2.77 5.35-2.18 6.7-.1-.65 10.14.11 21.3 4 31.22 1.06-1.07 23.96-16.94 24.3-69.95 2.83-2.95 11.02-2.37 10.84 2.27.92 14.44.08 37.52-4.08 50.87 10.76-3.7 22.11-4.93 33.67-3.44.23.02.46.05.69.09 1.1.14 2.2.32 3.3.51 1.49.28 2.98.59 4.47.95 2.85.4 2.62 5.14.62 6.45z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.4 77.77-7.41 6.57c-4.17-12.95-4.71-26.38-1.24-39.7 0 0-2.58 38.06 8.65 33.13z",
    fill: "#9e443d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.15 94.92c-.7.83-1.22 1.44-1.5 1.79-.01.02-.02.03-.03.06-.01.02-.05.04-.06.06-8.71 10.69-19.88 19.84-31.97 27.17-8.86-3.16-14-11.79-13.06-23.41 0 0 27.56 9.8 46.57-5.92z",
    fill: "#9e443d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.432 18.295c-3.572 2.713-8.183 4.02-12.647 3.584-1.185-.116-2.473-.418-3.178-1.377-1.022-1.39-.306-3.365.622-4.82 2.623-4.111 6.858-7.072 11.518-8.422 2.374-.688 4.875-.965 7.34-.761.841.07 2.769.044 3.123.85.335.764-.849 3.059-1.162 3.775-1.23 2.811-3.171 5.314-5.616 7.171z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.215 13.309c-7.775 3.133-14.911 8.025-20.67 14.083-.889.949-2.355-.4-1.463-1.364 3.108-3.055 6.568-5.693 10.228-7.983 3.654-2.27 7.522-4.199 11.582-5.612.559-.192.887.651.323.876z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.39 24.076c2.594 2.813 6.271 4.6 10.085 4.902 1.012.08 2.139.019 2.875-.681 1.067-1.015.76-2.78.198-4.141-1.588-3.845-4.702-6.965-8.413-8.796-1.891-.933-3.95-1.54-6.051-1.737-.717-.067-2.332-.378-2.75.247-.396.591.255 2.696.412 3.344.612 2.544 1.868 4.937 3.644 6.862z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.437 19.47c6.04 3.425 11.4 7.975 15.711 13.452.338.437.258 1.065-.179 1.403-.452.352-1.114.248-1.437-.225-3.858-5.466-8.91-10.216-14.572-13.816-.508-.313-.056-1.106.477-.814z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.25 41.7c-.23 2.1-.87 4.15-1.83 6.02-1.89 3.69-5.06 6.75-8.93 8.28-.1.04-.21.08-.32.11-1.1-.19-2.2-.37-3.3-.51-.23-.04-.46-.07-.69-.09-.52-.73-.55-1.75-.46-2.66.36-3.81 2.21-7.46 5.06-10.01 1.95-1.74 4.36-2.96 6.92-3.53.65-.15 2.76-.77 3.35-.36.62.42.28 2.03.2 2.75z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.589 55.417c3.349-2.917 6.441-6.237 8.931-9.951.324-.504 1.126-.016.823.504-2.271 4.015-5.155 7.626-8.392 10.911-.39.392-1.024.393-1.415.003-.414-.407-.388-1.091.053-1.467z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.906 35.505c-1.785 3.384-2.241 7.447-1.252 11.143.263.981.697 2.023 1.602 2.482 1.313.666 2.874-.212 3.969-1.196 3.094-2.781 4.995-6.758 5.481-10.868.248-2.094.132-4.237-.384-6.284-.176-.698-.423-2.325-1.151-2.51-.69-.175-2.456 1.141-3.015 1.505-2.192 1.429-4.028 3.412-5.25 5.728z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.357 36.856c-1.099 7.005-3.561 13.9-7.481 19.846-.295.467-.913.606-1.38.31-.481-.303-.611-.952-.285-1.417 4.066-5.658 6.666-12.125 8.039-18.951.147-.701 1.227-.505 1.107.212z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.008 80.737c-3.571-1.375-6.587-4.134-8.274-7.569-.448-.912-.806-1.982-.427-2.924.55-1.366 2.304-1.732 3.776-1.711 4.16.059 8.208 1.804 11.277 4.579 1.564 1.414 2.887 3.104 3.845 4.985.327.641 1.211 2.029.784 2.647-.404.586-2.601.756-3.261.85-2.589.37-5.276.084-7.72-.857z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.505 77.053c-6.321-4.775-13.747-8.173-21.524-9.191-.548-.072-.934-.574-.862-1.121.072-.559.598-.95 1.155-.857 8.145 1.345 15.674 5.131 21.973 10.221.595.483-.116 1.416-.742.948z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.705 95.459c-3.771.649-7.775-.175-10.983-2.261-.851-.553-1.708-1.289-1.864-2.292-.227-1.455 1.092-2.668 2.366-3.404 3.603-2.08 7.972-2.656 12.031-1.846 2.068.413 4.07 1.187 5.856 2.311.609.383 2.079 1.122 2.03 1.872-.047.71-1.846 1.982-2.365 2.401-2.036 1.643-4.49 2.774-7.071 3.219z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.974 90.921c-8.39-.78-17.124.504-24.876 3.751-1.209.5-1.995-1.295-.792-1.837 4.128-1.6 8.439-2.53 12.775-3.025 4.326-.471 8.705-.507 13.019.104.639.094.532 1.072-.126 1.007z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.904 112.819c-2.626-2.782-4.154-6.575-4.191-10.4-.01-1.015.129-2.135.879-2.821 1.086-.994 2.826-.566 4.145.089 3.726 1.851 6.623 5.173 8.192 9.002.8 1.951 1.262 4.047 1.314 6.157.018.72.215 2.353-.437 2.726-.617.354-2.672-.442-3.308-.642-2.496-.788-4.796-2.207-6.594-4.111z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.799 110.55c-3.657-7.034-9.152-13.062-15.741-17.326-1.088-.727-.033-2.378 1.087-1.679 6.726 4.712 12.155 11.169 15.633 18.52.294.628-.65 1.112-.979.485z",
    fill: "#ca6f63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.684 57.652c2.415 2.854 5.93 4.753 9.642 5.207.985.12 2.088.108 2.835-.545 1.084-.946.859-2.682.367-4.034-1.39-3.82-4.299-6.996-7.847-8.939-1.807-.99-3.792-1.668-5.835-1.948-.697-.096-2.261-.466-2.695.126-.411.561.137 2.643.262 3.282.492 2.509 1.618 4.897 3.271 6.851z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.87 53.252c6.999 4.389 13.302 10.118 17.399 17.412.267.484.091 1.092-.393 1.359s-1.092.091-1.359-.393c-3.618-7.147-9.589-13.03-16.185-17.545-.521-.348-.01-1.169.538-.833z",
    fill: "#9e443d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.331 47.007c-.505-.556-2.057-.01-2.756.162-2.049.505-3.995 1.41-5.728 2.612-2.247 1.559-4.14 3.643-5.464 6.037.156 2.798.451 5.611.924 8.397.426-.012.859-.082 1.269-.177 3.728-.862 7.101-3.173 9.251-6.337 1.472-2.166 2.36-4.718 2.591-7.325.059-.665.392-2.843-.087-3.369z",
    fill: "#97c2ad"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.771 54.386c-2.947 2.609-5.811 5.477-8.134 8.632-.77 1.055-2.386-.109-1.621-1.174 2.697-3.157 5.795-5.811 9.072-8.307.549-.41 1.202.395.683.849z",
    fill: "#ca6f63"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Humming_Bird"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Orchid"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Bbq"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Mushroom"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Raincoat"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Boot"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Rainy"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Flower"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Picnic_Basket"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Sprout"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Snail"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Ladybug"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Frog"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Tulip"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Bee"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Butterfly"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBranch);
export default __webpack_public_path__ + "static/media/branch.ffa9ef8189fdd509b097fe4da12b5e6d.svg";
export { ForwardRef as ReactComponent };